import React from 'react'
import { useTheme } from '@mui/material/styles'
import { parseISO } from 'date-fns'
import { safeFormat } from '@/v2/utils/convert'
import Typography from '@/v2/components/common/Typography'
import Day from './Day'
import { Column, Headline, BlankHeadline, HeadlineWrapper } from './styles'

const WeekDay = React.memo(props => {
  const theme = useTheme()
  const {
    date,
    hasHourRule,
    hasBorder,
    subjectView,
    typeFilter,
    loading,
    error,
    appointments,
    timeOffs,
    clinicHours,
    defaultStartHour,
    defaultEndHour,
  } = props

  return (
    <Column
      $hasHourRule={hasHourRule}
      $hasBorder={hasBorder}
      theme={theme.palette}
    >
      <HeadlineWrapper>
        {hasHourRule && <BlankHeadline />}
        <Headline>
          <Typography variant="h3">
            {safeFormat(parseISO(date), 'd EEEE')}
          </Typography>
        </Headline>
      </HeadlineWrapper>
      <Day
        date={date}
        view="week"
        subjectView={subjectView}
        typeFilter={typeFilter}
        loading={loading}
        error={error}
        appointments={appointments}
        timeOffs={timeOffs}
        clinicHours={clinicHours}
        defaultStartHour={defaultStartHour}
        defaultEndHour={defaultEndHour}
      />
    </Column>
  )
})

WeekDay.displayName = 'WeekDay'

export default WeekDay
